// React
import { useState } from "react"

export function useFilter(defaultValue: string) {
  // Hooks
  const [value, setValue] = useState(defaultValue)

  return { value, setValue }
}